import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const API_STATIC_URL = process.env.VUE_APP_ROOT_DISPLAY_STATIC;
const settingsServiceName = "Tag-Service: ";
const UPDATE_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/update';

export default class UpdateService {

    static async readAllUpdatesPaginated(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, ['description'], ['description']);
        await WrapperService.get(UPDATE_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
    }

    static async saveUpdate(update, file, successF, errorF) {

        let formData = new FormData();
        if (file && file.name) {
            formData.append("file", file, file.name);
        }
        formData.append("description", update.description);
        formData.append("version", update.version);
        formData.append("os", update.os);
        formData.append("channel", update.channel);
        formData.append("active", update.active);

        if (typeof update.id === 'undefined' || update.id === null) {
            await WrapperService.post(UPDATE_API_URL + '/upload', formData, settingsServiceName, successF, errorF);
        } else {
            await WrapperService.put(UPDATE_API_URL + '/upload/' + update.id, formData, settingsServiceName, successF, errorF);
        }
    }

    static async getFile(id, onSuccess, onError) {
        let url = API_STATIC_URL + '/update/' + id;
        await WrapperService.get(url, {responseType: 'blob'}, settingsServiceName,
            response => {
                onSuccess(response.data)
            },
            error => {
                if (onError) {
                    onError(error);
                }
            }
        )
    }

    static async deleteUpdate(id, successF, errorF) {
        await WrapperService.delete(UPDATE_API_URL + '/' + id, null, settingsServiceName, successF, errorF);
    }
}
